const video = document.querySelector('#product_description_video');
const playBtn = document.querySelector('#product_description_play_button');
const pauseBtn = document.querySelector('#product_description_pause_button');

if (playBtn && video) {
  playBtn.addEventListener('click', () => {
    video.play();
  });
}

if (pauseBtn && video) {
  pauseBtn.addEventListener('click', () => {
    video.pause();
  });
}

if (playBtn && pauseBtn && video) {
  video.addEventListener('playing', function () {
    playBtn.classList.remove('button_active');
    pauseBtn.classList.add('button_pause_active');
    if (!video.hasAttribute('controls')) {
      video.setAttribute('controls', true);
    }
  });

  video.addEventListener('pause', function () {
    playBtn.classList.add('button_active');
    pauseBtn.classList.remove('button_pause_active');
  });
}